import React, { FC } from 'react'

import { IconTabletProps } from './IconTablet.types'
import * as Styled from './styles/IconTablet.style'

import { nonThemeableRules } from '../../ruleSet'

const IconTablet: FC<IconTabletProps> = ({
  size = nonThemeableRules.defaultSize as number as IconTabletProps['size'],
  isResponsive = false,
}: IconTabletProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#528c4699-985e-4f09-8819-b99596d2bc9c__a)' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2'>
          <path d='M27 32.932h-6' stroke='#E60000' />
          <path d='M9 10.932h34v22a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4v-18a4 4 0 0 1 4-4v0Z' stroke='#0D0D0D' />
        </g>
        <defs>
          <clipPath id='528c4699-985e-4f09-8819-b99596d2bc9c__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconTablet
